import 'client-only';

export function getScroll(element = window) {
  return {
    scrollX: element.scrollX || document.documentElement.scrollLeft,
    scrollY: element.scrollY || document.documentElement.scrollTop,
  };
}
